module.exports = __webpack_public_path__ + "static/media/3DCommerce_RGB_Aug20.b36d8348.png";